import { Diversity3, Home, Storefront } from "@mui/icons-material";

/** Filled icons match `getNavLinks` / main app sidebar (not outlined variants). */
export const visitorManagementPrimaryNav = [
  { Icon: Home, end: true, label: "Home", to: "." },
  { Icon: Diversity3, end: false, label: "Reunification", to: "reunification" },
  { Icon: Storefront, end: false, label: "Kiosk", to: "kiosk" },
] as const;
